export default __webpack_public_path__ + "static/media/regulation.6975a577.svg";